import WebServiceRequest from "../WebServiceRequest";

class CreateFaqQuestionAnswer extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FAQQuestionAnswer/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetFaqQuestionAnswerList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FAQQuestionAnswer/GetList");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAFaqQuestionAnswer extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FAQQuestionAnswer/Delete");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}

class UpdateAFaqQuestionAnswer extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FAQQuestionAnswer/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetASingleFaqQuestionAnswer extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("FAQQuestionAnswer/Get");
  }
  setParams(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateFaqQuestionAnswer,
  GetFaqQuestionAnswerList,
  DeleteAFaqQuestionAnswer,
  UpdateAFaqQuestionAnswer,
  GetASingleFaqQuestionAnswer,
};
